let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Ce4d")).then(() => parcelRequire('33FPc'));